"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _localization = require("@lt/localization");
var _SearcherFilters = _interopRequireDefault(require("../SearcherAbstractFilters/SearcherFilters"));
var _Checkbox = _interopRequireDefault(require("../Checkbox"));
var SearcherFormFilters = function SearcherFormFilters(_ref) {
  var className = _ref.className,
    addServicesFilters = _ref.addServicesFilters,
    activeFilters = _ref.activeFilters,
    onSubmitFilters = _ref.onSubmitFilters,
    isMobile = _ref.isMobile,
    isHotelOnly = _ref.isHotelOnly,
    cashbackCount = _ref.cashbackCount,
    isCashbackPriceReductionOn = _ref.isCashbackPriceReductionOn,
    onToggleCashbackPriceReduction = _ref.onToggleCashbackPriceReduction,
    isOpenFiltersList = _ref.isOpenFiltersList;
  var _useTranslation = (0, _localization.useTranslation)(),
    t = _useTranslation.t;
  return /*#__PURE__*/_react["default"].createElement(Container, {
    className: className,
    isMobile: isMobile
  }, !(0, _isEmpty2["default"])(addServicesFilters) && /*#__PURE__*/_react["default"].createElement(_SearcherFilters["default"], {
    key: String(Object.values(activeFilters || {})),
    activeFilters: activeFilters,
    options: addServicesFilters,
    onSubmit: onSubmitFilters,
    isMobile: isMobile,
    isHotelOnly: isHotelOnly,
    isOpenFiltersList: isOpenFiltersList
  }), /*#__PURE__*/_react["default"].createElement(OperatorsAndCashbackPriceReductionWrapper, {
    isMobile: isMobile,
    isHotelOnly: isHotelOnly
  }, cashbackCount && cashbackCount > 0 ? /*#__PURE__*/_react["default"].createElement(CashbackPriceReduction, {
    isMobile: isMobile,
    isHotelOnly: isHotelOnly
  }, /*#__PURE__*/_react["default"].createElement(_Checkbox["default"], {
    checked: isCashbackPriceReductionOn,
    onClick: onToggleCashbackPriceReduction
  }, t('hotel.searcher.cashbackReduction.label'), /*#__PURE__*/_react["default"].createElement(CashbackCount, null, t('hotel.searcher.cashbackReduction.count', {
    count: cashbackCount
  })))) : null));
};
var Container = _styledComponents["default"].div.withConfig({
  displayName: "SearcherFormFilters__Container",
  componentId: "sc-deen4b-0"
})(["display:flex;justify-content:", ";", ""], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? 'space-between' : 'flex-start';
}, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile && 'width: 100%;';
});
var OperatorsAndCashbackPriceReductionWrapper = _styledComponents["default"].div.withConfig({
  displayName: "SearcherFormFilters__OperatorsAndCashbackPriceReductionWrapper",
  componentId: "sc-deen4b-1"
})(["display:flex;", " ", ""], function (_ref4) {
  var isMobile = _ref4.isMobile;
  return isMobile && 'flex-direction: column;';
}, function (_ref5) {
  var isMobile = _ref5.isMobile,
    isHotelOnly = _ref5.isHotelOnly;
  return !isMobile && !isHotelOnly && 'margin-left: 10px;';
});
var CashbackPriceReduction = _styledComponents["default"].div.withConfig({
  displayName: "SearcherFormFilters__CashbackPriceReduction",
  componentId: "sc-deen4b-2"
})(["", " ", ""], function (_ref6) {
  var isMobile = _ref6.isMobile;
  return isMobile ? 'margin-top: 8px;' : 'margin-left: 16px;';
}, function (_ref7) {
  var isHotelOnly = _ref7.isHotelOnly;
  return isHotelOnly && 'margin: 0;';
});
var CashbackCount = _styledComponents["default"].span.withConfig({
  displayName: "SearcherFormFilters__CashbackCount",
  componentId: "sc-deen4b-3"
})(["margin-left:4px;font-weight:bold;color:#5d6fb4;"]);
var _default = exports["default"] = SearcherFormFilters;